import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { IDescription } from "../../../models/profile";
import { ScreenMode } from "../../../models/enums";
import TextField from "material-ui/TextField";
import * as s from "./description.css";

@observer
export default class DescriptionEditor extends React.Component<{ store: SeekerStore, descriptor: IDescription, subHeading?: string }, {}> {
  constructor(props: any) {
    super(props);
  }
  @action handleChange = (event:any):void => {
    this.props.descriptor.desc = event.target.value;
  }
  render(): JSX.Element {
    const rowCt: number = (this.props.store.viewState.screenMode === ScreenMode.Mobile) ? 5 : 3;
    return <div>
      <p className={s.smallText}>{this.props.store.localization.fields.description}</p>
      <p className={s.smallSubText}>{this.props.subHeading ? this.props.subHeading : this.props.store.localization.fields.expRole}</p>
      <TextField className={s.textBackground} value={this.props.descriptor.desc || ""} onChange={this.handleChange} multiline={true} rows={rowCt} fullWidth />
      <br />
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/descriptionEditor/index.tsx